"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Thiana API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfConsultationOutput = instanceOfConsultationOutput;
exports.ConsultationOutputFromJSON = ConsultationOutputFromJSON;
exports.ConsultationOutputFromJSONTyped = ConsultationOutputFromJSONTyped;
exports.ConsultationOutputToJSON = ConsultationOutputToJSON;
var Consultation_1 = require("./Consultation");
var Metadata_1 = require("./Metadata");
/**
 * Check if a given object implements the ConsultationOutput interface.
 */
function instanceOfConsultationOutput(value) {
    if (!('data' in value) || value['data'] === undefined)
        return false;
    return true;
}
function ConsultationOutputFromJSON(json) {
    return ConsultationOutputFromJSONTyped(json, false);
}
function ConsultationOutputFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': (json['data'].map(Consultation_1.ConsultationFromJSON)),
        'metadata': json['metadata'] == null ? undefined : (0, Metadata_1.MetadataFromJSON)(json['metadata']),
    };
}
function ConsultationOutputToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'data': (value['data'].map(Consultation_1.ConsultationToJSON)),
        'metadata': (0, Metadata_1.MetadataToJSON)(value['metadata']),
    };
}
